import React from "react";
import { gridColumns_paymentActivity } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import GridLoadError from "../CommonGrid/GridLoadError";
import usePaymentActivity from "../../hooks/usePaymentActivity";

const PaymentActivityTable = ({ tHeight = "30vh", className, loanId }) => {
  const { error, paymentActivity, retry } = usePaymentActivity(loanId);

  return (
    <>
      {error ? (
        <div className={`col-12 col-sm-12 ${className}`}>
          <GridLoadError title="Payment History" onRetry={retry} />
        </div>
      ) : paymentActivity ? (
        <CommonGrid
          className={`col-sm-12 ${className}`}
          title={"Payment History"}
          gridColumns={gridColumns_paymentActivity}
          columnData={paymentActivity}
          // tHeight={tHeight}
        />
      ) : (
        <SpinnerBlock />
      )}
    </>
  );
};

export default PaymentActivityTable;
